var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 139,
    viewBox: "0 0 178 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_333",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 178,
    height: 139
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.903 0.435486H0.0967712V138.565H177.903V0.435486Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.193 76.5169C112.193 86.065 104.453 93.8053 94.905 93.8053C85.3569 93.8053 77.6166 86.065 77.6166 76.5169",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.517 67.3874C114.517 56.442 105.644 47.5691 94.6987 47.5691C83.7534 47.5691 74.8804 56.442 74.8804 67.3874",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5283 69.8223H122.566",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.759 127.819H61.3041V115.182C61.3041 106.329 68.4802 99.1534 77.3324 99.1534H84.8599V91.2112",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.402 90.9623V99.202H112.731C115.605 99.202 118.302 99.9584 120.634 101.283",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.482 110.623H74.5815V127.819H115.482V110.623Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41 99.202V110.623",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0424 99.202V110.623",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.595 127.819H161.226C162.522 127.819 163.573 126.769 163.573 125.472V120.278C163.573 118.982 162.522 117.931 161.226 117.931H123.595C122.299 117.931 121.248 118.982 121.248 120.278V125.472C121.248 126.769 122.299 127.819 123.595 127.819Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.595 117.789H161.226C162.522 117.789 163.573 116.738 163.573 115.442V110.247C163.573 108.951 162.522 107.9 161.226 107.9H126.563H123.595C122.299 107.9 121.248 108.951 121.248 110.247V115.442C121.248 116.738 122.299 117.789 123.595 117.789Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.595 107.758H127.216H161.226C162.522 107.758 163.573 106.707 163.573 105.411V100.217C163.573 98.9205 162.522 97.8698 161.226 97.8698H123.595C122.299 97.8698 121.248 98.9205 121.248 100.217V102.371V105.411C121.248 106.707 122.299 107.758 123.595 107.758Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.595 97.7273H161.226C162.522 97.7273 163.573 96.6766 163.573 95.3804V90.186C163.573 88.8898 162.522 87.8391 161.226 87.8391H123.595C122.299 87.8391 121.248 88.8898 121.248 90.186V95.3804C121.248 96.6766 122.299 97.7273 123.595 97.7273Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9827 17.3741C25.9827 17.3741 23.4757 35.0732 44.7444 35.135C44.7444 35.135 45.6851 15.2095 25.9827 17.3741Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2363 30.4618C64.2363 30.4618 46.8608 26.2623 44.7515 47.4263C44.7515 47.4263 64.4939 50.281 64.2363 30.4618Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4811 45.2295C23.4811 45.2295 40.2735 39.101 44.7515 59.893C44.7515 59.893 25.456 64.9517 23.4811 45.2295Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7444 35.135V70.3893",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3042 113.576C57.1654 119.061 50.593 122.606 43.1926 122.606C30.6691 122.606 20.5168 112.454 20.5168 99.9301C20.5168 87.4066 30.6691 77.2543 43.1926 77.2543C55.7161 77.2543 65.8683 87.4066 65.8683 99.9301C65.8683 101.379 65.7324 102.796 65.4727 104.17",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4248 122.745C56.4282 126.743 50.0896 129.134 43.1926 129.134C27.0636 129.134 13.9884 116.059 13.9884 99.9301C13.9884 83.8011 27.0636 70.7259 43.1926 70.7259C59.3216 70.7259 72.3967 83.8011 72.3967 99.9301",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.688 106.429H45.835C47.968 106.429 49.6972 104.699 49.6972 102.566C49.6972 100.433 47.968 98.7042 45.835 98.7042H41.5902C39.5402 98.7042 37.8782 97.0422 37.8782 94.9922C37.8782 92.9421 39.5402 91.2803 41.5902 91.2803H48.757",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1926 91.2803V86.6312",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1926 111.078V106.429",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon05.6a7428d3d2a18bca769b0e7b9e808553.svg";
export { ForwardRef as ReactComponent };